module.exports = __webpack_public_path__ + "static/media/slide-card.9fbe8647.svg";